import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center">
      <div className="w-8 h-8 rounded-full bg-red-600 relative mr-2">
        <div className="absolute top-0 right-0 w-2 h-2 bg-white rounded-full"></div>
      </div>
      <div>
        <h1 className="text-2xl font-bold">intCount</h1>
        <p className="text-gray-400 text-sm mt-1">Render Studio</p>
      </div>
    </div>
  );
};

export default Logo;
